import styled, { css } from "styled-components";
import { color } from "@m/alchemy-theme";
export const SHADOW_HEIGHT = 8;
export const BASE_Z_INDEX = 10;
export const BASE_PIN_OFFSET = 24;
export const STICKY_CLASS_NAME = "aui_isSticky";
export const PINNED_CLASS_NAME = "aui_isPinned";
export const StickyWrapper = styled.div `
  position: relative;
`;
export const Ghost = styled.div `
  pointer-events: none;
  position: relative;
  z-index: -1;
  visibility: hidden;

  * {
    visibility: hidden !important;
  }
`;
export const Positioner = styled.div `
  position: absolute;
  width: 100%;
  top: 0;
  overflow: hidden;

  /* Prevents a repaint somehow */
  transform: translateZ(0);
`;
export const Sizer = styled.div `
  /* Prevents a repaint somehow */
  transform: translateZ(0);
  position: relative;

  ${(props) => props.hasDropShadow &&
    css `
      &:after {
        pointer-events: none;
        background-image: linear-gradient(
          ${color("contrast", { opacity: 0.15 })},
          ${color("contrast", { opacity: 0 })}
        );
        content: "";
        height: ${SHADOW_HEIGHT}px;
        display: block;
        position: absolute;
        opacity: 0;
        transition: opacity 150ms ease-in-out;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: -1;
      }

      .${PINNED_CLASS_NAME} &:after,
      .${STICKY_CLASS_NAME} &:after {
        opacity: 1;
      }
    `}
`;
